import React from "react";

interface WithIsVisible {
  isVisible?: boolean;
}

// This function is the HOC that will inject an 'isVisible' prop into the wrapped component.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withIsVisible<T extends React.ComponentType<any>>(
  Component: T
): React.FC<React.ComponentProps<T> & WithIsVisible> {
  // This is the new component that the HOC produces.
  return ({ isVisible = true, ...props }: React.ComponentProps<T> & WithIsVisible) => {
    if (!isVisible) {
      return null;
    }

    // Render the wrapped component with the same props, ignoring isVisible.
    return <Component {...(props as React.ComponentProps<T>)} />;
  };
}
